import { render } from "./KidsCard.vue?vue&type=template&id=21883818&scoped=true"
import script from "./KidsCard.vue?vue&type=script&lang=js"
export * from "./KidsCard.vue?vue&type=script&lang=js"

import "./KidsCard.vue?vue&type=style&index=0&id=21883818&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21883818"]])

export default __exports__